import type { Layout } from "react-grid-layout"

// ─── Tower health layout ──────────────────────────────────────────────────────

export const towerTabLayoutLg: Record<string, Layout> = {
  TOWER_GLOBAL_LEAN: {
    w: 12,
    h: 3,
    x: 0,
    y: 0,
    minH: 0,
    i: "TOWER_GLOBAL_LEAN",
  },
  LOCATION: {
    w: 12,
    h: 3,
    x: 0,
    y: 3,
    minH: 0,
    i: "LOCATION",
  },
}

export const towerSegmentsTabLayoutLg: Record<string, Layout> = {
  TOWER_SEGMENT_BENDING_LONGITUDINAL: {
    w: 6,
    h: 3,
    x: 0,
    y: 0,
    minH: 0,
    i: "TOWER_SEGMENT_BENDING_LONGITUDINAL",
  },
  TOWER_SEGMENT_BENDING_LATERAL: {
    w: 6,
    h: 3,
    x: 6,
    y: 0,
    minH: 0,
    i: "TOWER_SEGMENT_BENDING_LATERAL",
  },
  TOWER_SEGMENT_BENDING_MAGNITUDE: {
    w: 12,
    h: 3,
    x: 0,
    y: 3,
    minH: 0,
    i: "TOWER_SEGMENT_BENDING_MAGNITUDE",
  },
  TOWER_SEGMENT_TORSION_TOTAL: {
    w: 12,
    h: 3,
    x: 0,
    y: 6,
    minH: 0,
    i: "TOWER_SEGMENT_TORSION_TOTAL",
  },
}

export const towerDevicesPlotsLayoutLg: Record<string, Layout> = {
  TOWER_DEVICES_FRONT_TILT: {
    w: 6,
    h: 3,
    x: 0,
    y: 0,
    minH: 0,
    i: "TOWER_DEVICES_FRONT_TILT",
  },
  TOWER_DEVICES_RIGHT_TILT: {
    w: 6,
    h: 3,
    x: 6,
    y: 0,
    minH: 0,
    i: "TOWER_DEVICES_RIGHT_TILT",
  },
  DEVICES_TILT_MAGNITUDE: {
    w: 12,
    h: 3,
    x: 0,
    y: 3,
    minH: 0,
    i: "DEVICES_TILT_MAGNITUDE",
  },
}

export const towerAmbientTabLayoutLg: Record<string, Layout> = {
  WEATHER_SERVICE_WIND_SPEED: {
    w: 9,
    h: 3,
    x: 0,
    y: 0,
    minH: 0,
    i: "WEATHER_SERVICE_WIND_SPEED",
  },
  LAST_WEATHER_SERVICE_WIND_SPEED: {
    w: 3,
    h: 3,
    x: 9,
    y: 0,
    minH: 0,
    i: "LAST_WEATHER_SERVICE_WIND_SPEED",
  },
  WEATHER_SERVICE_WIND_GUSTS: {
    w: 9,
    h: 3,
    x: 0,
    y: 3,
    minH: 0,
    i: "WEATHER_SERVICE_WIND_GUSTS",
  },
  LAST_WEATHER_SERVICE_WIND_GUSTS: {
    w: 3,
    h: 3,
    x: 9,
    y: 3,
    minH: 0,
    i: "LAST_WEATHER_SERVICE_WIND_GUSTS",
  },
  WEATHER_SERVICE_WIND_DIRECTION: {
    w: 9,
    h: 3,
    x: 0,
    y: 6,
    minH: 0,
    i: "WEATHER_SERVICE_WIND_DIRECTION",
  },
  LAST_WEATHER_SERVICE_WIND_DIRECTION: {
    w: 3,
    h: 3,
    x: 9,
    y: 6,
    minH: 0,
    i: "LAST_WEATHER_SERVICE_WIND_DIRECTION",
  },
  WEATHER_SERVICE_TEMPERATURE: {
    w: 9,
    h: 3,
    x: 0,
    y: 9,
    minH: 0,
    i: "WEATHER_SERVICE_TEMPERATURE",
  },
  LAST_WEATHER_SERVICE_TEMPERATURE: {
    w: 3,
    h: 3,
    x: 9,
    y: 9,
    minH: 0,
    i: "LAST_WEATHER_SERVICE_TEMPERATURE",
  },
  WEATHER_SERVICE_RELATIVE_HUMIDITY: {
    w: 9,
    h: 3,
    x: 0,
    y: 12,
    minH: 0,
    i: "WEATHER_SERVICE_RELATIVE_HUMIDITY",
  },
  LAST_WEATHER_SERVICE_RELATIVE_HUMIDITY: {
    w: 3,
    h: 3,
    x: 9,
    y: 12,
    minH: 0,
    i: "LAST_WEATHER_SERVICE_RELATIVE_HUMIDITY",
  },
  WEATHER_SERVICE_PRECIPITATION: {
    w: 9,
    h: 3,
    x: 0,
    y: 15,
    minH: 0,
    i: "WEATHER_SERVICE_PRECIPITATION",
  },
  LAST_WEATHER_SERVICE_PRECIPITATION: {
    w: 3,
    h: 3,
    x: 9,
    y: 15,
    minH: 0,
    i: "LAST_WEATHER_SERVICE_PRECIPITATION",
  },
}

// ─── Legacy (tower_health disabled) ──────────────────────────────────────────

export const towerInfoTabLayoutLg: Record<string, Layout> = {
  LOCATION: {
    w: 12,
    h: 3,
    x: 0,
    y: 0,
    minH: 0,
    i: "LOCATION",
  },
  DEVICES_TILT_MAGNITUDE: {
    w: 12,
    h: 3,
    x: 0,
    y: 3,
    minH: 0,
    i: "DEVICES_TILT_MAGNITUDE",
  },
  DEVICES_INCLINATION: {
    w: 12,
    h: 3,
    x: 0,
    y: 3,
    minH: 0,
    i: "DEVICES_INCLINATION",
  },
  TORSION: {
    w: 12,
    h: 3,
    x: 0,
    y: 6,
    minH: 0,
    i: "TORSION",
  },
  BENDING: {
    w: 12,
    h: 3,
    x: 0,
    y: 9,
    minH: 0,
    i: "BENDING",
  },
  WEATHER_SERVICE_WIND_SPEED: {
    w: 9,
    h: 3,
    x: 0,
    y: 12,
    minH: 0,
    i: "WEATHER_SERVICE_WIND_SPEED",
  },
  LAST_WEATHER_SERVICE_WIND_SPEED: {
    w: 3,
    h: 3,
    x: 9,
    y: 12,
    minH: 0,
    i: "LAST_WEATHER_SERVICE_WIND_SPEED",
  },
  WEATHER_SERVICE_WIND_GUSTS: {
    w: 9,
    h: 3,
    x: 0,
    y: 15,
    minH: 0,
    i: "WEATHER_SERVICE_WIND_GUSTS",
  },
  LAST_WEATHER_SERVICE_WIND_GUSTS: {
    w: 3,
    h: 3,
    x: 9,
    y: 15,
    minH: 0,
    i: "LAST_WEATHER_SERVICE_WIND_GUSTS",
  },
  WEATHER_SERVICE_WIND_DIRECTION: {
    w: 9,
    h: 3,
    x: 0,
    y: 18,
    minH: 0,
    i: "WEATHER_SERVICE_WIND_DIRECTION",
  },
  LAST_WEATHER_SERVICE_WIND_DIRECTION: {
    w: 3,
    h: 3,
    x: 9,
    y: 18,
    minH: 0,
    i: "LAST_WEATHER_SERVICE_WIND_DIRECTION",
  },
  WEATHER_SERVICE_TEMPERATURE: {
    w: 9,
    h: 3,
    x: 0,
    y: 21,
    minH: 0,
    i: "WEATHER_SERVICE_TEMPERATURE",
  },
  LAST_WEATHER_SERVICE_TEMPERATURE: {
    w: 3,
    h: 3,
    x: 9,
    y: 21,
    minH: 0,
    i: "LAST_WEATHER_SERVICE_TEMPERATURE",
  },
  WEATHER_SERVICE_RELATIVE_HUMIDITY: {
    w: 9,
    h: 3,
    x: 0,
    y: 24,
    minH: 0,
    i: "WEATHER_SERVICE_RELATIVE_HUMIDITY",
  },
  LAST_WEATHER_SERVICE_RELATIVE_HUMIDITY: {
    w: 3,
    h: 3,
    x: 9,
    y: 24,
    minH: 0,
    i: "LAST_WEATHER_SERVICE_RELATIVE_HUMIDITY",
  },
  WEATHER_SERVICE_PRECIPITATION: {
    w: 9,
    h: 3,
    x: 0,
    y: 27,
    minH: 0,
    i: "WEATHER_SERVICE_PRECIPITATION",
  },
  LAST_WEATHER_SERVICE_PRECIPITATION: {
    w: 3,
    h: 3,
    x: 9,
    y: 27,
    minH: 0,
    i: "LAST_WEATHER_SERVICE_PRECIPITATION",
  },
}
